import { Pagination } from '../../../shared/models/app.model';

export interface CustomerInformationList extends Pagination {
  content: CustomerInformation[];
}

export interface CustomerInformation {
  id: string;
  photo?: any;
  name: string;
  surname: string;
  customerName: string;
  nickname?: string;
  idCardNumber?: number;
  sex?: string;
  nationality?: string;
  tel1?: string;
  created?: number;
  updated?: number;
  status?: string;
}

export interface CustomerFullInformation extends CustomerInformation {
  prefix?: string;
  religion?: string;
  maritalStatus?: string;
  bloodType?: string;
  birthday?: number;
  passport?: string;
  nameEN?: string;
  surnameEN?: string;
  tel2?: string;
  address?: string;
  subDistrict?: string;
  district?: string;
  province?: string;
  zipCode?: string;
  note?: string;
  weight: number;
  height: number;
  drugAllergy?: string;
  mentalHealth?: string;
  congenitalDisease?: string;
  healthNote?: string;
}

export interface CardReaderInformation {
  data: CardData;
  message: string;
  success: boolean;
}

export interface CardData {
  address: string;
  citizenId: string;
  dateOfBirth: string;
  expireDate: string;
  firstNameEn: string;
  firstNameTh: string;
  gender: string;
  issueDate: string;
  lastNameEn: string;
  lastNameTh: string;
  middleNameEn: string;
  middleNameTh: string;
  photo: string;
  titleEn: string;
  titleTh: string;
}

export const SexOptions = [
  {
    key: 'M',
    value: 'M'
  },
  {
    key: 'F',
    value: 'F'
  },
  {
    key: 'UNSPECIFIED',
    value: 'UNSPECIFIED'
  }
];

export const MaritalStatusOptions = [
  {
    key: 'SINGLE',
    value: 'SINGLE'
  },
  {
    key: 'MARRIED',
    value: 'MARRIED'
  },
  {
    key: 'DIVORCED',
    value: 'DIVORCED'
  },
  {
    key: 'WIDOWED',
    value: 'WIDOWED'
  },
  {
    key: 'SEPARATED',
    value: 'SEPARATED'
  },
  {
    key: 'UNSPECIFIED',
    value: 'UNSPECIFIED'
  }
];

export const BloodTypeOptions = [
  {
    key: 'A',
    value: 'A'
  },
  {
    key: 'B',
    value: 'B'
  },
  {
    key: 'O',
    value: 'O'
  },
  {
    key: 'AB',
    value: 'AB'
  },
  {
    key: 'UNSPECIFIED',
    value: 'UNSPECIFIED'
  }
];
